import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ILote,
  ICreateLote,
  IListado,
  IQueryParam,
  IUpdateLote,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ZonasService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<ILote>> {
    let params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/zonas`, { params });
  }

  public crear(dato: ICreateLote): Observable<ILote> {
    return this.http.post(`${api}/zonas`, dato);
  }

  public listarPorId(id: string): Observable<ILote> {
    return this.http.get(`${api}/zonas/${id}`);
  }

  public editar(id: string, dato: IUpdateLote): Observable<ILote> {
    return this.http.put(`${api}/zonas/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/zonas/${id}`);
  }
}
